import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-702ed0ee")

_pushScopeId("data-v-702ed0ee")
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "description" }
const _hoisted_3 = { style: {"margin-bottom":"16px"} }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_m_page_header = _resolveComponent("m-page-header")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("header", null, [
      _createVNode(_component_m_page_header, { title: "操作指南" })
    ]),
    _createVNode("main", null, [
      _createVNode("div", _hoisted_2, [
        _createVNode("ul", null, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.steps, (text, index) => {
            return (_openBlock(), _createBlock("li", {
              key: text,
              style: {"margin-bottom":"24px"}
            }, [
              _createVNode("p", _hoisted_3, _toDisplayString(text), 1),
              _createVNode("img", {
                src: _ctx.imgMap['home' + (index + 1)],
                style: {"width":"800px","border-radius":"4px"}
              }, null, 8, ["src"])
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
})